<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <!-- frameに有効なフレームが代入されていたら使用済み画面 -->
    <TemplateSheetUsed
      v-if="isReadyToDraw && frame.stamped_at"
      :issuedExternalCoupon="issuedExternalCoupon"
    />

    <!-- 使用前画面 -->
    <TemplateSheet
      v-else-if="isReadyToDraw"
      :isInIntervalFlag="isInIntervalFlag"
      :nextTimeAvailable="nextTimeAvailable"
    />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />
  </div>
  <!---全体を囲む--->
</template>

<script>
// Vueファイル
import TemplateSheet from "@/views/Templates/MyTickets/TemplateSheet";
import TemplateSheetUsed from "@/views/Templates/MyTickets/TemplateSheetUsed";

// Service
import sheetService from "@/services/sheet";
import frameService from "@/services/frame";

// Vue
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

// JSプラグイン
import moment from "@/services/moment";
import { parse } from "querystring";

import nativeHandlerService from "@/services/nativeHandler";

import storeJS from "@/store";
import routerJS from "@/router";

try {
  // QRコード結果受信→Vue内のvalidメソッドを実行
  window.jcSetQRCode = function (qrCodeText) {
    const route = routerJS.currentRoute._rawValue;
    const query = parse(qrCodeText);

    // fnc == "PRX"ならSetQRへリダイレクト
    if (query.fnc == "PRX") {
      routerJS.push({
        name: "SetQR",
        query: {
          fnc: "PRX",
          key: query.key,
        },
      });
      return;
    }

    // fnc == "PRX"以外ならSheetValidへリダイレクト
    routerJS.push({
      name: "SheetValid",
      params: {
        book_group_id: route.params.book_group_id,
        book_id: route.params.book_id,
        sheet_id: route.params.sheet_id,
      },
      query: {
        fnc: query.fnc,
        master_book_id: query.master_book_id,
        master_sheet_id: query.master_sheet_id,
        type: query.type,
        location_id: query.location_id,
        mamoru_auth: query.mamoru_auth,
      },
    });
  };
} catch (err) {
  alert(err);
}

// QRコードが読み込めず、救済コード画面へ遷移させるwindow関数→Vue内のredirectメソッドを実行
window.jcRedirectToEmergencyCode = function () {
  // 救済コード入力画面へ
  try {
    const route = routerJS.currentRoute._rawValue;

    // 複数枚の場合と1枚の場合で代入
    var sheetID = route.params.sheet_id.match(/,/)
      ? route.params.sheet_id.split(",")[0]
      : route.params.sheet_id;

    routerJS.push({
      name: "SheetEmergencyCode",
      params: {
        book_group_id: route.params.book_group_id,
        sheet_id: sheetID,
        frame_id: storeJS.getters["ticketing/frame"].id,
      },
      query: { language: storeJS.getters["common/lang"] },
    });
  } catch (err) {
    alert(err);
  }
};

export default {
  components: {
    TemplateSheet: TemplateSheet,
    TemplateSheetUsed: TemplateSheetUsed,
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const isReadyToDraw = ref(false);

    let isInIntervalFlag = ref(false);
    let nextTimeAvailable = ref("");

    const frame = computed(() => store.getters["ticketing/frame"]);
    const unused_frames = computed(
      () => store.getters["ticketing/unused_frames"]
    );
    const used_frames = computed(() => store.getters["ticketing/used_frames"]);

    const issuedExternalCoupon = ref(null);

    onMounted(async () => {
      try {
        nativeHandlerService.ncAppVersion();

        // シートフローの中で必要なAPIを取得し、それぞれのデータをstoreへcommit
        await sheetService.getSheetInfomations(route);

        const bookGroup = store.getters["ticketing/bookGroup"];
        const masterSheet = store.getters["ticketing/masterSheet"];
        const sheet = store.getters["ticketing/sheet"];

        // 1日に複数回使用可能なシート(主にEmotパス)ならsetMultipleFrame
        if (masterSheet.use_interval != "1days") {
          console.log("object :>> setMultipleFrame");

          // 使用済み・未使用のフレームArrayを弾き出してストアへ
          let [return_used_frames, return_unused_frames] =
            await frameService.setMultipleFrame(sheet);
          store.commit("ticketing/setFrames", {
            used_frames: return_used_frames,
            unused_frames: return_unused_frames,
          });

          // もし使用済みフレームが存在するなら、その中にまだ有効なフレームがあるかを調べる必要がある
          if (return_used_frames.length > 0) {
            console.log(
              "使用済みフレームが存在するならその中にまだ有効なフレームがあるかを調べる必要がある :>> getFrameAndIntervalFlag"
            );
            let intervalLimit = await sheetService.getIntervalLimit(
              masterSheet,
              sheet
            );
            const [returnFrame, returnIsInIntervalFlag] =
              await frameService.getFrameAndIntervalFlag(
                intervalLimit,
                masterSheet,
                return_used_frames,
                return_unused_frames
              );
            store.commit("ticketing/setFrame", returnFrame);
            isInIntervalFlag.value = returnIsInIntervalFlag;
            nextTimeAvailable.value = moment(new Date(intervalLimit)).format(
              "MM.DD HH:mm:ss"
            );
          } else {
            console.log("使用済みフレームがない(未使用)");
            // もし未使用ならfalseの一択 フレームは空で設定
            isInIntervalFlag.value = false;
            if (masterSheet.is_fixed_frame) {
              // APIにリクエストするフレームは未使用の先頭で設定
              store.commit("ticketing/setFrame", return_unused_frames[0]);
            } else {
              // サブスク型の場合は空で設定
              store.commit("ticketing/setFrame", {});
            }
          }

          // この時点でストアのフレームがnullなら空{}で設定
          if (store.getters["ticketing/frame"] == null) {
            store.commit("ticketing/setFrame", {});
          }
        } else {
          // 1日に1回しかフレームを使えないシートなのでsetFrames
          console.log("object :>> setFrames");
          const returnFrames = await frameService.setFrames(bookGroup, sheet);
          // 今は複数シートの使用のパターンがないので先頭を指定するだけでいい
          store.commit("ticketing/setFrame", returnFrames[0]);
        }

        console.log(
          "Sheet onMounted isInIntervalFlag :>> ",
          isInIntervalFlag.value
        );
        console.log(
          "Sheet onMounted nextTimeAvailable :>> ",
          nextTimeAvailable.value
        );
        console.log("Sheet onMounted frame :>> ", frame.value);
        console.log("Sheet onMounted unused_frames :>> ", unused_frames.value);
        console.log("Sheet onMounted used_frames :>> ", used_frames.value);

        // ワンタイムパス入力/MamoruQR読み込みでリダイレクトしてきた場合はメニュー表示
        if (
          (route.query.onetime || route.query.mamoru_auth) &&
          !isInIntervalFlag.value
        ) {
          // メニュー画面へ移動
          redirectToSheetMenu();
          return false;
        }
        // setQRからのリダイレクトでノーマルQRの場合
        if (
          route.query.fromQR &&
          !isInIntervalFlag.value &&
          route.query.type == "normal"
        ) {
          // sheetValidに遷移してそちらで処理
          redirectToSheetValid();
        }

        if (route.query.issuedExternalCoupon != null) {
          issuedExternalCoupon.value =
            route.query.issuedExternalCoupon == 1 ? true : false;
          console.log(
            "Sheet.issuedExternalCoupon::",
            issuedExternalCoupon.value
          );
        }

        isReadyToDraw.value = true;
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "Sheet onMounted()",
          JSON.stringify(err)
        );
      }
    });

    // メニュー画面へ移動
    const redirectToSheetMenu = () => {
      router.push({
        name: "SheetMenu",
        query: {
          book_group_id: route.params.book_group_id,
          sheet_id: route.params.sheet_id,
          onetime: route.query.onetime,
          mamoru_auth: route.query.mamoru_auth,
          location_id: route.query.location_id,
        },
      });
    };

    // sheetValid画面へ移動
    const redirectToSheetValid = () => {
      router.push({
        name: "SheetValid",
        params: {
          book_group_id: route.params.book_group_id,
          book_id: route.params.book_id,
          sheet_id: route.params.sheet_id,
        },
        query: {
          fnc: route.query.fnc,
          master_book_id: route.query.master_book_id,
          master_sheet_id: route.query.master_sheet_id,
          type: route.query.type,
          location_id: route.query.location_id,
        },
      });
    };

    return {
      isReadyToDraw,
      frame,
      isInIntervalFlag,
      nextTimeAvailable,
      issuedExternalCoupon,
    };
  },
};
</script>
